

import initmixin from "@/Services/initmixin";

export default {
 
  //mixins: [initmixin],
 // GET_CLIENTES CREAR_CLIENTES EDITAR_CLIENTES ELIMINAR_CLIENTES

 GET: async function( data){
      let url='/clientes/page/'+data.page+'/search/'+data.search
      return initmixin.formatrespuesta('get', data.data,url,true)
    },
    CREAR: async function( data) {
      let url='/clientes/'
      return initmixin.formatrespuesta('post', data,url,true)
    },
    EDITAR: async function( data) {
      let url='/clientes/'+data.id
      return initmixin.formatrespuesta('put', data,url,true)
    },
    ELIMINAR: async function( data) {
      let url='/clientes/'+data.id
      return initmixin.formatrespuesta('delete', data,url,true)
    },
   


}